// Vendors
import { requestHasSuccessStatus } from '@openbank/cf-ui-framework';
// Utilities
import { expireCurrentOrderService } from 'services/expire-order.service';

const expireCurrentOrderResolver = async (): Promise<[boolean]> => {
  const [, { status }] = await expireCurrentOrderService();

  return [requestHasSuccessStatus(status)];
};

export { expireCurrentOrderResolver };
